var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseOrderReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 682.667 682.667",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 682.667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-66.274-53.726-120-120-120S-240-66.274-240 0s53.726 120 120 120S0 66.274 0 0Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 135)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h16.667c9.205 0 16.666-7.462 16.666-16.667v-16.666C33.333-42.538 25.872-50 16.667-50H0c-9.205 0-16.667 7.462-16.667 16.667",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(127.666 135)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-16.667c-9.205 0-16.666 7.462-16.666 16.667v16.666c0 9.205 7.461 16.667 16.666 16.667H0c9.205 0 16.667-7.462 16.667-16.667",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(144.333 135)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(136 185)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v20",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(136 65)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h330c16.568 0 30 13.432 30 30v351.997L260.004 482H30c-16.568 0-30-13.432-30-30V240",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(136 15)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-100h100Z",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(396 497)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h210.638",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(215.362 225)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h220",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(206 315)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h170",
    style: {
      strokeWidth: 30,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(256 135)",
    fill: "none",
    stroke: "#999999",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "none",
    strokeOpacity: "",
    "data-original": "#000000",
    opacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseOrderReport);
export default __webpack_public_path__ + "static/media/purchase-order-report.db64fe3ed0dbde7208744716df03b7b1.svg";
export { ForwardRef as ReactComponent };